// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"257801aa","454":"e67709db","526":"3fe6e398","588":"9ff1d877","883":"0ca16ed2","966":"3fe6e398"}[chunkId] + ".chunk.css";
};